import { TableSkeleton } from '@/components/Table';

export const FacesheetAnalysisSkeleton = () => {
  return (
    <div className="rounded-lg border bg-white p-6">
      <h2 className="mb-4 text-lg font-semibold">Analysis</h2>
      <TableSkeleton rows={3} columns={6} showHeader />
    </div>
  );
};
